import { configureStore } from '@reduxjs/toolkit'
import reducer from './reducers'
import middlewares from './middlewares'

export const store = configureStore({
  reducer,
  devTools: {},
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      // We have been haunted with this error in our console.
      // "A non-serializable value was detected in an action, in the path: `payload.confirmBoxProps.onOk`"
      // So I guess we'll disable the check until we sort this out.
      serializableCheck: false,
    }).concat(middlewares),
})
